export const LOAD_REWARD = 'rewardsStore/RewardRedeemDetailsPage/LOAD_REWARD';
export const LOAD_REWARD_SUCCESS = 'rewardsStore/RewardRedeemDetailsPage/LOAD_REWARD_SUCCESS';
export const LOAD_REWARD_ERROR = 'rewardsStore/RewardRedeemDetailsPage/LOAD_REWARD_ERROR';

export const SUBMIT_REDEMPTION = 'rewardsStore/RewardRedeemDetailsPage/SUBMIT_REDEMPTION';
export const SUBMIT_REDEMPTION_SUCCESS = 'rewardsStore/RewardRedeemDetailsPage/SUBMIT_REDEMPTION_SUCCESS';
export const SUBMIT_REDEMPTION_ERROR = 'rewardsStore/RewardRedeemDetailsPage/SUBMIT_REDEMPTION_ERROR';

export const CANCEL_REDEMPTION = 'rewardsStore/RewardRedeemDetailsPage/CANCEL_REDEMPTION';
export const CANCEL_REDEMPTION_SUCCESS = 'rewardsStore/RewardRedeemDetailsPage/CANCEL_REDEMPTION_SUCCESS';
export const CANCEL_REDEMPTION_ERROR = 'rewardsStore/RewardRedeemDetailsPage/CANCEL_REDEMPTION_ERROR';
